/**
 * PacmanSprite - CSS-only Pac-Man character
 */

import type { PacmanState, Direction } from '../../types/pacman';
import { TILE_SIZE } from '../../types/pacman';
import './PacmanSprite.css';

interface PacmanSpriteProps {
  pacman: PacmanState;
}

export function PacmanSprite({ pacman }: PacmanSpriteProps) {
  const rotation = getRotation(pacman.direction);

  return (
    <div
      className={`pacman-sprite ${pacman.mouthOpen ? 'pacman-sprite--open' : 'pacman-sprite--closed'}`}
      style={{
        left: pacman.position.x - TILE_SIZE / 2,
        top: pacman.position.y - TILE_SIZE / 2,
        transform: `rotate(${rotation}deg)`,
      }}
    />
  );
}

function getRotation(direction: Direction): number {
  switch (direction) {
    case 'RIGHT': return 0;
    case 'DOWN': return 90;
    case 'LEFT': return 180;
    case 'UP': return 270;
  }
}
